export const OwnerField: OwnerFieldType = {
  name: 'name',
  city: 'city',
  address: 'address',
  state: 'state',
  zip: 'zip',
  phone: 'phone',
  website: 'website',
  salesforce_id: 'salesforce_id',
  status: 'status'
};
type OwnerFieldType = {
  name: 'name';
  city: 'city';
  address: 'address';
  state: 'state';
  zip: 'zip';
  phone: 'phone';
  website: 'website';
  salesforce_id: 'salesforce_id';
  status: 'status';
};

export interface IOwner {
  id: OwnerId;
  name: string;
  city?: string;
  address?: string;
  state?: string;
  zip?: string;
  phone?: string;
  website?: string;
  salesforce_id: string;
  status: 'ACTIVE' | 'DISABLED';
  linkedPropertiesCount?: number;
}

export interface IOwnerRequest {
  owner: IOwner;
}

export type OwnerId = string;

export interface IOwnerUpdateRequest {
  owner: Partial<IOwner>;
}

export interface IOwnerResponse {
  data: IOwner | IOwner[];
  page?: number;
  rowsPerPage?: number;
  count?: number;
}

export interface IAvailabilityCheckResponse {
  data: {
    available: boolean;
  };
}

// Property interface for available properties
export interface IAvailableProperty {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  status: string;
  short_id: string;
  company_name: string;
  company_id: string;
}

export interface IAvailablePropertiesResponse {
  data: IAvailableProperty[];
  page: number;
  rowsPerPage: number;
  count: number;
}
